import { useEffect, useState } from 'react';

/** Seconds until another code may be asked for, ticking down once a second; 0 means it may be asked for now. */
export function useResendCountdown() {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const isRunning = secondsLeft > 0;

  useEffect(() => {
    if (!isRunning) return undefined;
    const timer = setInterval(() => setSecondsLeft((left) => Math.max(0, left - 1)), 1000);
    return () => clearInterval(timer);
  }, [isRunning]);

  return { secondsLeft, start: setSecondsLeft };
}
